import { render, staticRenderFns } from "./du-service.vue?vue&type=template&id=ca26f5d0&"
import script from "./du-service.vue?vue&type=script&lang=js&"
export * from "./du-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports